import React from 'react';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const SocialImpaceBanner = ({ data }) => {
  const { headline, bg, fg } = data;
  const { file } = bg?.fields || fg?.fields;

  return (
    <div className='social-impact-banner' data-testid='social-impact-banner'>
      <div className='strip-icon d-flex justify-content-center'>
        <ImageComponent srcFile={IMAGE_PATH?.StripesIconWhite} />
      </div>
      <div className='banner-container d-flex align-items-center flex-column flex-lg-row justify-content-around'>
        <div className='column-one'>
          <h1 className='banner-heading'>{headline}</h1>
        </div>
        <div className='column-two'>
          <ImageComponent srcFile={file?.url} />
        </div>
      </div>
    </div>
  );
};

export default SocialImpaceBanner;
